import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import React, { FC } from "react";
import { DocumentFile } from "../../../types";
import { DocumentFileSortableItem } from "./DocumentFileSortableItem";
import { DroppableListContainer } from "components/DroppableListContainer";

type Props = {
  title: string,
  documents: DocumentFile[],
  droppableContainerId: string,
  isMobile?: boolean,
  actionLabel?: string,
  actionIcon?: IconProp,
  actionVariant?: 'contained' | 'outlined',
  onAction?: (document: DocumentFile) => void,
}

export const DroppableList: FC<Props> = ({
  title,
  documents,
  droppableContainerId,
  isMobile = false,
  actionLabel,
  actionIcon,
  actionVariant,
  onAction,
}) => {
  return (
    <DroppableListContainer title={title} items={documents} droppableContainerId={droppableContainerId}>
      <SortableContext
        items={documents.map(item => item._id)}
        strategy={verticalListSortingStrategy}
      >
        {documents.map(item => (
          <DocumentFileSortableItem
            key={item._id}
            documentFile={item}
            isMobile={isMobile}
            actionLabel={actionLabel}
            actionIcon={actionIcon}
            actionVariant={actionVariant}
            onAction={onAction ? () => onAction(item) : undefined}
          />
        ))}
      </SortableContext>
    </DroppableListContainer>
  );
};
